import type { StaffRoleModel } from '../app/types/staff-member.type.ts';
import baseApi from './meeting-md-api-slice';

const staffRoleApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchStaffMemberRoles: builder.query<StaffRoleModel[], void>({
      query() {
        return `/staffRole`;
      },
    }),
  }),
});

export const { useFetchStaffMemberRolesQuery } = staffRoleApi;
